import * as React from 'react';
const classNames = require('classnames');
import QuotePlan from './QuotePlan';
import QuotePlanDetails from './QuotePlanDetails';

interface Props {
	className?: string;
	planOptions: CustomerPolicy[];
	onCustomerPolicySelect: (plan: CustomerPolicy) => void;
	workflow: string;
	isLoading: boolean;
}
const PlanOptions: React.StatelessComponent<Props> = props => {
	return (
		<div>
			<div className={classNames('quote-plans', props.className)}>
				{props.planOptions.map((option, index) => (
					<QuotePlan
						key={index}
						workflow={props.workflow}
						option={option}
						onCustomerPolicySelect={props.onCustomerPolicySelect}
						isLoading={props.isLoading}
					>
						{props.workflow === 'B' && (
							<QuotePlanDetails
								items={[
									{
										description: (
											<span>
												<strong>Partial</strong> income replacement
											</span>
										),
										enabled: true
									},
									{ description: 'Mortgage & debt protection', enabled: true },
									{ description: 'Post-secondary coverage', enabled: false }
								]}
							/>
						)}
					</QuotePlan>
				))}
			</div>
			<div className="text-center">
				<em>Rates may change based on lifestyle</em>
			</div>
		</div>
	);
};

export default PlanOptions;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/PlanOptions.tsx